
import React from 'react';
import { Dialog } from '@/components/ui/dialog';
import { CollectionDialogContent } from './collection/CollectionDialogContent';

interface CollectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  showOnlyWithPaymentData?: boolean;
}

export const CollectionDialog: React.FC<CollectionDialogProps> = ({
  open,
  onOpenChange,
  showOnlyWithPaymentData = true
}) => {
  // Закрыть диалог при нажатии Escape
  React.useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && open) {
        onOpenChange(false);
      }
    };

    window.addEventListener('keydown', handleEscapeKey);
    return () => {
      window.removeEventListener('keydown', handleEscapeKey);
    };
  }, [open, onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <CollectionDialogContent 
        onClose={() => onOpenChange(false)}
        onOpenChange={onOpenChange}
        showOnlyWithPaymentData={showOnlyWithPaymentData}
        open={open}
      />
    </Dialog>
  );
};
